import { render, staticRenderFns } from "./richTextH5.vue?vue&type=template&id=cb4cd368&scoped=true&"
import script from "./richTextH5.vue?vue&type=script&lang=ts&"
export * from "./richTextH5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4cd368",
  null
  
)

export default component.exports